export default {
  "menu.welcome": "welcome",
  "menu.more-blocks": "More block",
  "menu.home": "front page",
  "menu.admin": "Management page",
  "menu.admin.sub-page": "Second -level management page",
  "menu.login": "Log in",
  "menu.register": "register",
  "menu.register.result": "Register",
  "menu.dashboard": "Dashboard",
  "menu.dashboard.analysis": "Analysis page",
  "menu.dashboard.monitor": "Monitoring page",
  "menu.dashboard.workplace": "Workbench",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.form": "Table page",
  "menu.form.basic-form": "Basic form",
  "menu.form.step-form": "Stepping table",
  "menu.form.step-form.info": "Steposcope (fill in transfer information)",
  "menu.form.step-form.confirm": "Steposcope (confirming transfer information)",
  "menu.form.step-form.result": "Steposcope (completion)",
  "menu.form.advanced-form": "High -level form",
  "menu.list": "List",
  "menu.list.table-list": "Query form",
  "menu.list.basic-list": "Standard list",
  "menu.list.card-list": "Card list",
  "menu.list.search-list": "Search list",
  "menu.list.search-list.articles": "Search list (article)",
  "menu.list.search-list.projects": "Search List (Project)",
  "menu.list.search-list.applications": "Search list (application)",
  "menu.profile": "Details page",
  "menu.profile.basic": "Basic details page",
  "menu.profile.advanced": "Advanced detail page",
  "menu.result": "Result page",
  "menu.result.success": "Successful page",
  "menu.result.fail": "Failed page",
  "menu.exception": "Abnormal pages",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "Trigger error",
  "menu.account": "Personal page",
  "menu.account.center": "Personal center",
  "menu.account.settings": "Personal settings",
  "menu.account.trigger": "Trigger an error",
  "menu.account.logout": "sign out",
  "menu.editor": "Graphic editor",
  "menu.editor.flow": "Flow editor",
  "menu.editor.mind": "Brain",
  "menu.editor.koni": "Topology editor",
  "menu.setting": "Column Settings",
  "menu.sys-settings": "System settings",
  "menu.sys-settings.org-mng": "Institutional management",
  "menu.sys-settings.role-mng": "Role management",
  "menu.sys-settings.role-add": "Role management",
  "menu.sys-settings.user-mng": "Employee management",
  "menu.customer": "Customer management",
  "menu.customer.label-mng": "Label management",
  "menu.customer.level-mng": "Grade management",
  "menu.customer.team-mng": "Team management",
  "menu.customer.my-customer": "Customer",
  "menu.customer.org-customer": "Institutional client",
  "menu.customer.public-customer": "Potential Customers",
  "menu.customer.satisfaction": "Service Evaluation Record",
  "menu.customer.add-customer": "Create a member file",
  "menu.customer.customer-detail": "Customer Details",
  "menu.customer.customer-report-detail": "Health Reports",
  "menu.customer.customer-package": "Service Configuration",
  "menu.customer.message-board": "Leave a message management",
  "menu.service": "Service management",
  "menu.service.package-manage": "Service Package",
  "menu.service.package-add": "Service package management",
  "menu.service.services": "Service Item",
  "menu.service.service-update": "Service item update",
  "menu.service.bind-records": "Binding record",
  "menu.service.record-create": "Add service record",
  "menu.task": "Task view",
  "menu.task.task-view-1": "I deal with",
  "menu.task.task-view-2": "I created",
  "menu.task.task-view-3": "I transfer to",
  "menu.task.task-view-4": "My client",
  "menu.task.task-view-5": "All tasks",
  "menu.task.create-task": "New Tasks",
  "menu.task.task-process": "Processing task",
  "menu.task.task-process-detail": "Task Details",
  "menu.task.task-print": "Task printing",
  "menu.assessment": "Health Assessment",
  "menu.assessment.assessment-records": "Evaluation record",
  "menu.assessment.assessment-report-mental-detail": "Psychological health",
  "menu.assessment.assessment-report-physique-detail": "Physical identification",
  "menu.assessment.assessment-report-risk-detail": "Health risk",
  "menu.shopping": "Store management",
  "menu.shopping.promotion": "Promotions",
  "menu.shopping.promotion-add": "Add Activity",
  "menu.shopping.order-manage": "Mall order",
  "menu.shopping.order-form": "Appointment order",
  "menu.shopping.detail-list": "order details",
  "menu.shopping.promote-order": "Promotion order",
  "menu.shopping.commodity-manger": "Product management",
  "menu.shopping.item-controller": "Appointment project management",
  "menu.shopping.category-manger": "Commodity category settings",
  "menu.shopping.order-category-controller": "Preparation category settings",
  "menu.shopping.commodity-options": "Create Products",
  "menu.shopping.category-addEdit": "Create an appointment project",
  "menu.shopping.mall-shop": "Store settings",
  "menu.shopping.mall-create": "Shop edit",
  "menu.shopping.mall-freight": "Shipping Fee ",
  "menu.order-administrate": "Appointment management",
  "menu.online-inquiry": "Online consultation",
  "menu.online-inquiry.inquiry-history": "Consultation history",
  "menu.online-inquiry.inquiry-schedule": "Sort setting",
  "menu.content": "knowledge base",
  "menu.content.content-intervention": "Intervention plan template",
  "menu.content.add-intervention": "Intervention plan template details",
  "menu.content.content-medicine": "Pharmaceutical library",
  "menu.content.service-plan": "Service solution template",
  "menu.content.add-service-plan": "Details of Service Plan Template",
  "menu.content.sms-template": "SMS template library",
  "menu.content.return-visit": "Back to Visit Library",
  "menu.content.add-return-visit": "Details of Return Call",
  "menu.content.sport-plan": "Motion warehouse",
  "menu.content.add-sport-plan": "Details Of Physical Exercise Plan",
  "menu.content.content-food": "Dietary Portal",
  "menu.content.add-food-plan": "Details of meals",
  "menu.operation": "Operating management",
  "menu.operation.operation-information": "Health Information",
  "menu.operation.operation-MicroMedicalOrders": "Micro -medical order",
  "menu.operation.microMedicalOrders-detail": "Micro -medicine order details",
  "menu.operation.add-information": "Health information details",
  "menu.statistics": "Statistical Analysis",
  "menu.statistics.service": "Health pipe service analysis",
  "menu.statistics.customer": "Customer Analysis",
  "menu.equipment": "Equipment management",
  "menu.equipment.equipment-view": "Device view",
  "menu.equipment.equipment-register": "Device registration",
  "menu.equipment.registration-list": "Equipment registration list",
  "menu.equipment.equipment-detail": "Device details page",
  "menu.healthHut": "Health Centre",
  "menu.healthHut.equipment-hut": "House test record",
  "menu.healthHut.hut-manage": "Healthy House Management",
  "menu.healthHut.add-hut": "Add healthy hut",
  "menu.physicalManage": "Medical examination management",
  "menu.physicalManage.reportList": "Health Reports",
  "menu.physicalManage.reportUpload": "Upload New Report",
  "menu.healthHut.test-report": "Report Type",
  "menu.healthHut.zhaiker": "Housekeeper",
  "menu.operate.new": "Add",
  "menu.operate.edit": "Edit",
  "menu.operate.copy": "Duplicate",
  "menu.operate.view": "View",
  "menu.operate.add": "Add",
  'menu.operate.enable': 'Enable',
  'menu.operate.disable': 'Disable',
  'menu.operate.delete': 'Delete',
  'menu.confirmTitle.delete': 'Do you want to delete?',
  "menu.status.zero": "Not start",
  "menu.status.one": "Underway",
  "menu.status.two": "Finished",
  "menu.status.three": "Disable",
  "menu.level.zero": "Ideal",
  "menu.level.one": "Mild",
  "menu.level.two": "Moderate",
  "menu.level.three": "Biased",
  "menu.level.four": "Serious",
  "menu.time.one": " Normal ",
  "menu.time.two": "Will expire",
  "menu.time.three": "Expired",
  "menu.time.four": "Cancelled",
  "menu.report.data": "Data report",
  "menu.report.images": "Image report",
  "menu.report.pdf": "PDF report",
  "menu.report.manual": "Excel Report",
  "menu.record.one": "Outpatient record",
  "menu.record.two": "Emergency record",
  "menu.record.three": "Surgery record",
  "menu.medicine.one": "Taking medicine",
  "menu.medicine.two": "Discontinued",
  "menu.medicine.three": "Not started",
  "menu.sms": "SMS management",
  "menu.sms.sms-query": "SMS query",
  "menu.sms.group-message": "Group SMS",
  "menu.sms.group-record": "Group record query",
  "menu.sys-notice": "System notification",
  "menu.sys-notice.sys-announcement": "System announcement",
  "menu.sys-notice.sys-notification": "System notification",
  "menu.publicAccount": "Public account news",
  "menu.publicAccount.publicAccount-message": "Public account message",
}
